import React, { FC } from 'react';
import Form from 'react-bootstrap/Form';
import { useFormContext } from 'react-hook-form';
import styled from 'styled-components';

interface IFormSwitchProps {
  name: string;
  isDisabled?: boolean;
}

/*
 * Abstracted check component, displaying form control switch.
 */
const FormSwitch: FC<IFormSwitchProps> = ({ name, isDisabled }) => {
  const { register } = useFormContext<any>();
  return (
    <SwitchWrapper>
      <Form.Check
        custom
        disabled={isDisabled}
        className="custom-switch-control"
        type="switch"
        {...register(name)}
      />
    </SwitchWrapper>
  );
};

// In order to customize the switch button, we need this wrapper.
// Please first look at `bootstrap.scss` and all the customized switch settings there.
// Due to an issue related to `bootstrap` calculations I've added some more settings here.
//
// In case we need different size switches or
// other types with custom settings let's review and rethink again.
// If this `react-bootstrap` switch could not cover a new type,
// we can replace it with a fully custom switch component.
const SwitchWrapper = styled.div`
  .custom-switch-control {
    padding-top: 6px;
    padding-bottom: 6px;

    .custom-control-label {
      &::before {
        height: 1.25rem;
      }
    }

    .custom-control-input:checked ~ .custom-control-label {
      &::after {
        transform: translateX(1.45rem);
      }
    }
  }
`;

export default FormSwitch;
